import { Box, Flex, Icon, Link, Text, VStack } from '@chakra-ui/react'
import { FolderOpen, SearchX } from 'lucide-react'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import urls from '~/constants/urls'
import { useContactsListEmptyNoticeStyle } from '~/pages/Contacts/componentStyles/ContactsListEmptyNotice.style'

interface ContactsListEmptyNoticeProps {
  searchTerm?: string
}
export const ContactsListEmptyNotice = ({
  searchTerm,
}: ContactsListEmptyNoticeProps) => {
  const { t } = useTranslation()
  const variant = searchTerm ? 'search' : undefined
  const styles = useContactsListEmptyNoticeStyle({ variant: variant })
  const emptyNoticeContent = useMemo(() => {
    if (!searchTerm || searchTerm.length === 0) {
      return (
        <>
          <Icon as={FolderOpen} css={styles.icon} />
          <Text css={styles.warningText}>
            {t('contactsListView.emptyNotice.noContactsYet')}
          </Text>
          <Text css={styles.descriptionText}>
            {t('contactsListView.emptyNotice.contactSupport')}{' '}
            <Link href={urls.ADMIN} target="_blank">
              {urls.ADMIN.replace('https://', '')}
            </Link>
          </Text>
        </>
      )
    }

    return (
      <>
        <Icon css={styles.icon}>
          <SearchX size="100%" />
        </Icon>
        <Text css={styles.warningText}>
          {t('contactsListView.emptyNotice.noContactsFound')}
        </Text>
        <Box textAlign="center">
          <Text css={styles.descriptionText}>
            {t('contactsListView.emptyNotice.noMatchingContacts')}{' '}
          </Text>
          <Text css={styles.searchContextText}>"{searchTerm}"</Text>
        </Box>
      </>
    )
  }, [searchTerm, styles, t])
  return (
    <Flex css={styles.container} width="100%" height="100%">
      <VStack display="flex" css={styles.contentStack}>
        {emptyNoticeContent}
      </VStack>
    </Flex>
  )
}
